import useTypedFlags from "hooks/useTypedFlags";

import DashboardWidgetsOpenTofuMigrationProvider from "../OpenTofuMigration/Provider";
import DashboardWidgetsStacksRequiringAttention from "../StacksRequiringAttention";
import DashboardWidgetsStacksRequiringAttentionProvider from "../StacksRequiringAttention/Provider";
import DashboardWidgetsVendorMigrationTabbedVendors from "./components/TabbedVendors";

const DashboardWidgetsVendorMigration = () => {
  const { opentofuBackend } = useTypedFlags();

  return (
    <DashboardWidgetsStacksRequiringAttentionProvider>
      {opentofuBackend && (
        <DashboardWidgetsOpenTofuMigrationProvider>
          <DashboardWidgetsVendorMigrationTabbedVendors />
        </DashboardWidgetsOpenTofuMigrationProvider>
      )}
      {!opentofuBackend && <DashboardWidgetsStacksRequiringAttention />}
    </DashboardWidgetsStacksRequiringAttentionProvider>
  );
};

export default DashboardWidgetsVendorMigration;
